import { Card } from '../../../Common/Charts/Card';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import { number } from '../../../Common/Util/number';

export const Total = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div className="w-100">
            <Card
                title="Total de Autorizações de Internação Hospitalar"
                value={number.formatToBRNumber(
                    chartData?.selectedYear
                        ?.filter(
                            (item) => item.description === 'Total - Ano Atual'
                        )
                        .reduce(
                            (acc, curr) => acc + Number(curr.services),
                            0
                        ) || 0
                )}
            />
        </div>
    );
};
